import KeyPartyModal from "./KeyPartyModal";
export type { KeyPartyModalProps } from "./KeyPartyModal";
export default KeyPartyModal;
